<template>
  <div class="w-full flex">

    <!-- Preview for form editor -->
    <div v-if="productData == null" class="w-full flex gap-1 items-center">
      <input
          :readonly="true"
          class="outline-0 border border-trader-input-border p-1 w-full my-1 shadow-inner-2"
          :class="{ 'bg-inactive' : true}"
      >
    </div>

    <!-- Fieldtype -->
    <div v-else class="w-full flex flex-col items-center">

      <div class="flex flex-col relative w-full">

        <input
            :readonly="true" placeholder="Template auswählen"
            class="outline-0 border border-trader-input-border p-1 w-full my-1 shadow-inner-2"
            :class="{ 'bg-inactive' : true}" @click="openTemplateList"
            :value="selectedTemplates.map((t) => t.name).join(', ')"
        >

        <div v-if="showDropdown"
             class="absolute top-6 left-0 border border-trader-input-border p-1 w-full shadow-inner-2 h-64 bg-white overflow-auto grid grid-cols-2 z-10">
          <div v-for="template in templates" class="m-1  justify-center  gap-1 p-1"
               :class="[selectedTemplates.includes(template) ? 'bg-trader-blue' : 'bg-trader-gray']"
               @click="() => { onSelectTemplate(template) }">

            <div class="flex flex-col">


              <div>
                <ShowPreviewProduct class="h-full" :page-id="page?.pageId" :product-id="productData.productId"
                                    :template-id="template.id"
                                    :highlight="false"/>
              </div>
              <p>{{ template.name }}</p>
            </div>
          </div>
        </div>

      </div>


      <div class="grid grid-cols-2 min-h-64">

        <template v-for="template in selectedTemplates">
          <div class="m-1 bg-trader-gray flex justify-center">
            <object type="image/svg+xml" class="w-full h-full"
                    :data="'/api/v3/preview/page/'+page?.pageId+'/product/'+productData.productId+'/template/'+template.id+'?callback=p1101218'">
              <param name="type" value="image/svg+xml">
            </object>
          </div>
        </template>
      </div>

    </div>

  </div>
</template>

<script>
import apolloClient from "@/apolloClient";
import {GET_INDESIGN_TEMPLATES} from "@/store/modules/graphql";
import ShowPreviewProduct from "@/components/Preview/showPreviewProduct.vue";
import {mapState} from "vuex";

export default {
  meta: {
    name: "Article Template Select",
    type: "fieldtype",
    version: "1.0.0",
    hasOptions: true,
    hideLabel: true,
  },
  components: {ShowPreviewProduct},
  props: {
    name: "Article Template Select",
    formField: {
      type: Object,
      default: {}
    },
    productData: {
      type: Object,
      default: () => {
      }
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {
      }
    },
    getFieldValue: {
      type: Function,
      default: () => {
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDropdown: false,
      templates: [],
      selectedTemplates: [],
    }
  },
  computed: {
    ...mapState('page', ['page']),
    value() {
      return this.getFieldValue(this.formField.field);
    }
  },
  methods: {
    openTemplateList() {
      
      if (!this.readOnly) {
        this.showDropdown = !this.showDropdown;
      }
    },
    onSelectTemplate(template) {
      if (this.selectedTemplates.includes(template)) {
        this.selectedTemplates = this.selectedTemplates.filter((t) => t.id !== template.id);
      } else {
        this.selectedTemplates.push(template);
      }
      this.onChangeProductFieldValue(this.formField.field, null, this.selectedTemplates.map((t) => t.id).join(', '))
    },
    loadSelectedTemplates(fieldName) {
      const templateIds = this.productData.customFields[fieldName]?.value?.split(',') || [];

      templateIds.forEach((id, index) => {
        templateIds[index] = parseInt(id);
      });

      this.selectedTemplates = this.templates.filter((t) => templateIds.includes(t.id));
    },
  },
  mounted() {
    // return if productData is not set
    if (this.productData == null) {
      return;
    }

    apolloClient.query({
      query: GET_INDESIGN_TEMPLATES,
      variables: {type: "articletemplate", categoryId: 286}
    }).then((response) => {
      this.templates = response.data.getInDesignTemplates;
      this.loadSelectedTemplates(this.formField.field);
    })
  }
}
</script>


